import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import {
  getAllRequests,
  getAllCategories,
  getPersonalisedRequests,
} from "../../apis";
import {
  Container,
  Stack,
  FormControl,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import FeedRequestCard from "./components/FeedRequestCard";
import SelectedRequest from "./components/SelectedRequest";
import FeedsSkeleton from "./components/FeedsSkeleton";

const Feeds = () => {
  let user = {};
  user = JSON.parse(localStorage.getItem("user-info"));
  let userID = user.googleId ? user.googleId : user._id;
  const [allRequests, setAllRequests] = useState([]);
  const [category, setCategory] = useState("");
  const [distance, setDistance] = useState("");
  const [price, setPrice] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [categoriesData, setCategoriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  // const categories = [
  //   { label: "AC Services", value: "AC Services" },
  //   { label: "Cleaning Services", value: "Cleaning Services" },
  //   { label: "Salon and Self Care", value: "Salon and Self Care" },
  //   { label: "Plumbing Services", value: "Plumbing Services" },
  //   { label: "Electrician Services", value: "Electrician Services" },
  //   { label: "Appliances Maintenance", value: "Appliances Maintenance" },
  //   { label: "Packaging and Movers", value: "Packaging and Movers" },
  //   { label: "Pest Control", value: "Pest Control" },
  // ];

  useEffect(() => {
    const getData = async () => {
      const response = await getPersonalisedRequests(userID);
      setAllRequests(response.data.requests);
      const result = await getAllCategories();
      setCategoriesData(result.data.categories);
      let arr = [];
      result.data.categories.map((item) => {
        arr.push({ label: item.name, value: item.name });
      });
      setCategories(arr);
    };
    getData();
  }, []);

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const RequestClickhandler = (id) => {
    const filteredResult = allRequests.filter((item) => item._id == id);
    setSelectedRequest(filteredResult[0]);
  };

  return (
    <>
      <Navbar />
      {/* <Container> */}
      <Grid container>
        <Grid item sm={6}>
          <Container>
            <Stack direction="row" spacing={4} className="ml-16">
              <h2>Requests</h2>
              <Stack direction="row" spacing={4} alignItems="center">
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={category}
                      onChange={handleCategoryChange}
                      autoWidth
                    >
                      <MenuItem disabled value="">
                        <em>Category</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={distance}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem disabled value="">
                        <em> Distance</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={price}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem disabled value="">
                        <em> Price</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                <Stack>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sortBy}
                      onChange={handleCategoryChange}
                    >
                      <MenuItem disabled value="">
                        <em>Sort by</em>
                      </MenuItem>
                      {categories.map((item) => (
                        <MenuItem value={item.value}>{item.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
              </Stack>
            </Stack>
            <div
              style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
              className="mb-16 ml-16"
            >
              <Stack spacing={2}>
                {allRequests.length ? (
                  allRequests.map((request) => (
                    <FeedRequestCard
                      title={request.title}
                      location={request.address}
                      fromDate={request.fromDate}
                      urgent={request.urgent}
                      details={request.details}
                      id={request._id}
                      clickHandler={RequestClickhandler}
                    />
                  ))
                ) : (
                  <>
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                    <FeedsSkeleton />
                  </>
                )}
              </Stack>
            </div>
          </Container>
        </Grid>
        <Grid item sm={6}>
          {selectedRequest != null ? (
            <SelectedRequest currentRequest={selectedRequest} />
          ) : null}
        </Grid>
      </Grid>
      {/* </Container> */}
    </>
  );
};

export default Feeds;
